import React from "react";
import { Checkbox, FormControlLabel } from "@material-ui/core";
import Tooltip from "components/Tooltip";

const style = {
  display: "flex",
  alignItems: "center",
};

const CheckBox = ({ size, label, color = "primary", tooltip, ...rest }) => {
  return (
    <div style={style}>
      <FormControlLabel
        control={<Checkbox color={color} {...rest} />}
        label={label}
      />
      <Tooltip text={tooltip} />
    </div>
  );
};

export default CheckBox;
